import type { CSSProperties } from 'react'

const fonts = {
  signifier: '--next-font-signifier',
  switzer: '--next-font-switzer',
} as const

const typography: TypeStyles = {
  h1: {
    'font-family': `var(${fonts.signifier})`,
    'font-style': 'normal',
    'font-weight': 300,
    'line-height': '118%',
    'letter-spacing': '0em',
    'font-size': { mobile: 38, desktop: 55 },
  },
  h2: {
    'font-family': `var(${fonts.signifier})`,
    'font-style': 'normal',
    'font-weight': 400,
    'line-height': '102%',
    'letter-spacing': '0em',
    'font-size': { mobile: 45, desktop: 45 },
  },
  h3: {
    'font-family': `var(${fonts.signifier})`,
    'font-style': 'normal',
    'font-weight': 400,
    'line-height': '120%',
    'letter-spacing': '0em',
    'font-size': { mobile: 36, desktop: 36 },
  },
  'h4-l': {
    'font-family': `var(${fonts.signifier})`,
    'font-style': 'normal',
    'font-weight': 400,
    'line-height': '102%',
    'letter-spacing': '0em',
    'font-size': { mobile: 26, desktop: 34 },
  },
  h4: {
    'font-family': `var(${fonts.signifier})`,
    'font-style': 'normal',
    'font-weight': 400,
    'line-height': '102%',
    'letter-spacing': '0em',
    'font-size': { mobile: 26, desktop: 24 },
  },
  h5: {
    'font-family': `var(${fonts.switzer})`,
    'font-style': 'normal',
    'font-weight': 600,
    'line-height': '102%',
    'letter-spacing': '0em',
    'font-size': { mobile: 22, desktop: 20 },
  },
  h6: {
    'font-family': `var(${fonts.switzer})`,
    'font-style': 'normal',
    'font-weight': 600,
    'line-height': '124%',
    'letter-spacing': '0em',
    'font-size': { mobile: 16, desktop: 14 },
  },
  'p-xl': {
    'font-family': `var(${fonts.switzer})`,
    'font-style': 'normal',
    'font-weight': 400,
    'line-height': '124%',
    'letter-spacing': '0em',
    'font-size': { mobile: 18, desktop: 18 },
  },
  'p-l': {
    'font-family': `var(${fonts.switzer})`,
    'font-style': 'normal',
    'font-weight': 400,
    'line-height': '124%',
    'letter-spacing': '0em',
    'font-size': { mobile: 16, desktop: 15 },
  },
  'p-xxl': {
    'font-family': `var(${fonts.switzer})`,
    'font-style': 'normal',
    'font-weight': 500,
    'line-height': '124%',
    'letter-spacing': '0em',
    'font-size': { mobile: 14, desktop: 22 },
  },
  p: {
    'font-family': `var(${fonts.switzer})`,
    'font-style': 'normal',
    'font-weight': 500,
    'line-height': '124%',
    'letter-spacing': '0em',
    'font-size': { mobile: 14, desktop: 14 },
  },
  'p-s': {
    'font-family': `var(${fonts.switzer})`,
    'font-style': 'normal',
    'font-weight': 400,
    'line-height': '124%',
    'letter-spacing': '0em',
    'font-size': { mobile: 14, desktop: 12 },
  },
  'p-xs': {
    'font-family': `var(${fonts.switzer})`,
    'font-style': 'normal',
    'font-weight': 500,
    'line-height': '124%',
    'letter-spacing': '0em',
    'font-size': { mobile: 12, desktop: 12 },
  },
  username: {
    'font-family': `var(${fonts.switzer})`,
    'font-style': 'normal',
    'font-weight': 700,
    'line-height': '124%',
    'letter-spacing': '0em',
    'font-size': { mobile: 14, desktop: 12 },
  },
  'cta-rg-l': {
    'font-family': `var(${fonts.switzer})`,
    'font-style': 'normal',
    'font-weight': 400,
    'line-height': '124%',
    'letter-spacing': '0em',
    'font-size': { mobile: 16, desktop: 14 },
  },
  'cta-rg': {
    'font-family': `var(${fonts.switzer})`,
    'font-style': 'normal',
    'font-weight': 400,
    'line-height': '124%',
    'letter-spacing': '0em',
    'font-size': { mobile: 14, desktop: 14 },
  },
  'cta-rg-s': {
    'font-family': `var(${fonts.switzer})`,
    'font-style': 'normal',
    'font-weight': 400,
    'line-height': '124%',
    'letter-spacing': '0em',
    'font-size': { mobile: 12, desktop: 18 },
  },
  'cta-md-l': {
    'font-family': `var(${fonts.switzer})`,
    'font-style': 'normal',
    'font-weight': 500,
    'line-height': '124%',
    'letter-spacing': '0em',
    'font-size': { mobile: 18, desktop: 14 },
  },
  'cta-md': {
    'font-family': `var(${fonts.switzer})`,
    'font-style': 'normal',
    'font-weight': 500,
    'line-height': '124%',
    'letter-spacing': '0em',
    'font-size': { mobile: 16, desktop: 14 },
  },
  'cta-md-s': {
    'font-family': `var(${fonts.switzer})`,
    'font-style': 'normal',
    'font-weight': 500,
    'line-height': '124%',
    'letter-spacing': '0em',
    'font-size': { mobile: 14, desktop: 12 },
  },
  'cta-sb-l': {
    'font-family': `var(${fonts.switzer})`,
    'font-style': 'normal',
    'font-weight': 600,
    'line-height': '124%',
    'letter-spacing': '0em',
    'font-size': { mobile: 16, desktop: 22 },
  },
  'cta-sb': {
    'font-family': `var(${fonts.switzer})`,
    'font-style': 'normal',
    'font-weight': 600,
    'line-height': '124%',
    'letter-spacing': '0em',
    'font-size': { mobile: 14, desktop: 12 },
  },
  'cta-sb-s': {
    'font-family': `var(${fonts.switzer})`,
    'font-style': 'normal',
    'font-weight': 600,
    'line-height': '124%',
    'letter-spacing': '0em',
    'font-size': { mobile: 12, desktop: 18 },
  },
  quote: {
    'font-family': `var(${fonts.switzer})`,
    'font-style': 'normal',
    'font-weight': 400,
    'line-height': '124%',
    'letter-spacing': '0em',
    'font-size': { mobile: 22, desktop: 22 },
  },
  'nav-cta': {
    'font-family': `var(${fonts.switzer})`,
    'font-style': 'normal',
    'font-weight': 400,
    'line-height': '100%',
    'letter-spacing': '0em',
    'font-size': { mobile: 14, desktop: 20 },
  },
} as const

export { fonts, typography }

// UTIL TYPES
type TypeStyles = Record<
  string,
  {
    'font-family': string
    'font-style': CSSProperties['fontStyle']
    'font-weight': CSSProperties['fontWeight']
    'line-height':
      | `${number}%`
      | { mobile: `${number}%`; desktop: `${number}%` }
    'letter-spacing':
      | `${number}em`
      | { mobile: `${number}em`; desktop: `${number}em` }
    'font-feature-settings'?: string
    'font-size': number | { mobile: number; desktop: number }
  }
>
